<template>
  <div>
    <data-table
      ref="notVote"
      :module-info="moduleInfoResult"
      :toolbar-btns="[]"
      :tb-columns="tbColumns"
      :on-list-data-before-load="onListDataBeforeLoad"
      :on-cell-click="onCellClick"
    />
  </div>
</template>

<script>
export default {
    components: {

    },
    props: {
        id: { type: String, default: function() { return '' } }
    },
    data() {
        return {
            moduleInfoResult: {
                listDataUrl: '/hygl/voteResult/listdata'
            },
            tbColumns: [
                {
                    field: 'index',
                    title: '序号',
                    width: '45px',
                    align: 'center',
                    valign: 'middle'
                },
                {
                    field: 'deptName',
                    title: '部门',
                    align: 'left',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' }},
                    sortable: true
                },
                {
                    field: 'voteName',
                    title: '投票人',
                    width: '250px',
                    align: 'left',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' }},
                    sortable: true
                },
                {
                    field: 'phoneNumber',
                    title: '联系方式',
                    width: '250px',
                    align: 'left',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' }},
                    sortable: true
                }
            ]
        }
    },
    computed: {

    },
    created() {

    },
    beforeDestroy() {

    },
    mounted() {
        this.$refs.notVote.$el.childNodes[0].style = 'display:none'
    },
    methods: {
        onListDataBeforeLoad($scope, qparams) {
            qparams.urlsearch = ''
            qparams.searchMap = {
                status: 1,
                voteId: this.id,
                choiceStatus: 1
            }
        },
        onCellClick() {
        }
    }
}
</script>

<style scoped lang="scss">

</style>
